import * as React from 'react';

export const EmptyGridChildPlaceholder: React.FunctionComponent<{}> = () => (
  <div></div>
);
